export class EventType {
    id: string;
    backgroundColor: string;
    fontColor: string;
}
